(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var drawer = document.getElementById('cart-drawer');
    var backdrop = document.getElementById('cart-drawer-backdrop');
    var closeBtn = document.getElementById('cart-drawer-close');

    function openDrawer() {
      if (window.closeNavMenu) window.closeNavMenu();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;

    drawer.addEventListener('click', function(e) {
      if (e.target.closest('#cart-drawer-close')) closeDrawer();
    });
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Quantity buttons — update via AJAX then re-render section
    document.getElementById('cart-drawer').addEventListener('click', function(e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (!btn) return;

      var key = btn.dataset.cartQty;
      var delta = parseInt(btn.dataset.delta);
      var valEl = btn.parentElement.querySelector('.cart-drawer__qty-val');
      var current = parseInt(valEl.textContent);
      var max = btn.dataset.max ? parseInt(btn.dataset.max) : 9999;
      var newQty = Math.max(0, current + delta);
      if (newQty > max) return;

      fetch(shopRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Update CART[x] in header buttons immediately
        document.querySelectorAll('.site-header__cart-text, .site-header-compact__cart-text').forEach(function(btn) {
          var cartTitle = document.documentElement.dataset.cartTitle || 'CART';
          btn.textContent = cartTitle + '[' + cart.item_count + ']';
        });
        document.querySelectorAll('.site-header__cart-badge, .site-header-compact__cart-badge').forEach(function(badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // Re-render the drawer section
        return fetch(shopRoot + '?sections=cart-drawer');
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['cart-drawer'];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var curPanel = drawer.querySelector('.cart-drawer__panel');

        // Swap header (count update)
        var newHeader = tmp.querySelector('.cart-drawer__header');
        var curHeader = drawer.querySelector('.cart-drawer__header');
        if (newHeader && curHeader) curHeader.innerHTML = newHeader.innerHTML;

        // Swap body
        var newBody = tmp.querySelector('#cart-drawer-body');
        var curBody = document.getElementById('cart-drawer-body');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;

        // Swap footer
        var newFooter = tmp.querySelector('.cart-drawer__footer');
        var curFooter = drawer.querySelector('.cart-drawer__footer');
        if (newFooter && curFooter) {
          curFooter.innerHTML = newFooter.innerHTML;
        } else if (newFooter && !curFooter) {
          curPanel.appendChild(newFooter);
        } else if (!newFooter && curFooter) {
          curFooter.remove();
        }

      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.qtyChange;
        var delta = parseInt(btn.dataset.delta);
        var display = document.getElementById('qty-' + key);
        var current = parseInt(display.textContent);
        var max = btn.dataset.max ? parseInt(btn.dataset.max) : 9999;
        var newQty = Math.max(0, current + delta);
        if (newQty > max) return;

        fetch(shopRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (newQty === 0) {
            location.reload();
          } else {
            display.textContent = newQty;
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    // ── Desktop sort by ──────────────────────────────
    var sortBtn = document.querySelector('[data-sortby-btn]');
    var sortList = document.querySelector('[data-sortby-list]');
    if (sortBtn && sortList) {
      sortBtn.addEventListener('click', function() {
        var isOpen = sortBtn.getAttribute('aria-expanded') === 'true';
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
        sortList.hidden = isOpen;
      });
      document.addEventListener('click', function(e) {
        if (!sortBtn.contains(e.target) && !sortList.contains(e.target)) {
          sortBtn.setAttribute('aria-expanded', 'false');
          sortList.hidden = true;
        }
      });
      sortList.querySelectorAll('[data-sort]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', btn.dataset.sort);
          window.location.href = url.toString();
        });
      });
    }

    // ── Drawer open / close ──────────────────────────
    var filterOpen = document.getElementById('coll-filter-open');
    var filterClose = document.getElementById('coll-filter-close');
    var filterDrawer = document.getElementById('coll-filter-drawer');
    var filterOverlay = document.getElementById('coll-filter-overlay');

    function openDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      filterOverlay.classList.add('is-open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      filterOverlay.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (filterOpen) filterOpen.addEventListener('click', openDrawer);
    if (filterClose) filterClose.addEventListener('click', closeDrawer);
    if (filterOverlay) filterOverlay.addEventListener('click', closeDrawer);

    // ── AJAX filter — drawer stays open ─────────────
    function filterWithUrl(url) {
      var page = document.querySelector('.coll-page');
      if (page) page.classList.add('is-loading');

      var openLabels = [];
      if (filterDrawer) {
        filterDrawer.querySelectorAll('.coll-page__accord--open .coll-page__accord-btn span:first-child').forEach(function(s) {
          openLabels.push(s.textContent.trim());
        });
      }

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newGrid = doc.querySelector('.coll-page__grid');
          var oldGrid = document.querySelector('.coll-page__grid');
          if (newGrid && oldGrid) oldGrid.outerHTML = newGrid.outerHTML;

          var newPag = doc.querySelector('.coll-page__pagination');
          var oldPag = document.querySelector('.coll-page__pagination');
          if (oldPag) oldPag.outerHTML = newPag ? newPag.outerHTML : '';

          var newCount = doc.querySelector('.coll-page__count');
          var oldCount = document.querySelector('.coll-page__count');
          if (newCount && oldCount) oldCount.outerHTML = newCount.outerHTML;

          var newDrawer = doc.getElementById('coll-filter-drawer');
          if (filterDrawer && newDrawer) {
            filterDrawer.innerHTML = newDrawer.innerHTML;
            filterDrawer.querySelectorAll('.coll-page__accord-btn').forEach(function(btn) {
              var label = btn.querySelector('span:first-child');
              if (label && openLabels.indexOf(label.textContent.trim()) !== -1) {
                btn.setAttribute('aria-expanded', 'true');
                btn.closest('.coll-page__accord').classList.add('coll-page__accord--open');
              }
            });
            initPriceSliders();
          }

          history.pushState({}, '', url);
          var refreshedPage = document.querySelector('.coll-page');
          if (refreshedPage) refreshedPage.classList.remove('is-loading');
          openDrawer();
        })
        .catch(function() {
          if (page) page.classList.remove('is-loading');
          window.location.href = url;
        });
    }

    // ── Event delegation on drawer ───────────────────
    if (filterDrawer) {
      filterDrawer.addEventListener('click', function(e) {
        var accordBtn = e.target.closest('.coll-page__accord-btn');
        if (accordBtn) {
          var accord = accordBtn.closest('.coll-page__accord');
          var isOpen = accordBtn.getAttribute('aria-expanded') === 'true';
          accordBtn.setAttribute('aria-expanded', String(!isOpen));
          accord.classList.toggle('coll-page__accord--open', !isOpen);
          return;
        }

        var filterLink = e.target.closest('.coll-page__drawer-filter');
        if (filterLink) {
          e.preventDefault();
          filterWithUrl(filterLink.href);
          return;
        }

        var chip = e.target.closest('.coll-page__active-chip');
        if (chip) {
          e.preventDefault();
          filterWithUrl(chip.href);
          return;
        }

        var drawerSort = e.target.closest('[data-drawer-sort]');
        if (drawerSort) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', drawerSort.dataset.drawerSort);
          var page = document.querySelector('.coll-page');
          if (page) page.classList.add('is-loading');
          window.location.href = url.toString();
          return;
        }

        var applyBtn = e.target.closest('.coll-page__price-apply');
        if (applyBtn) {
          var slider = applyBtn.closest('.coll-page__price-slider');
          if (slider) {
            var tMin = slider.querySelector('.coll-page__price-thumb--min');
            var tMax = slider.querySelector('.coll-page__price-thumb--max');
            var param = slider.dataset.param || 'filter.p.m.price';
            var url = new URL(window.location.href);
            // Thumbs hold cents; the filter URL params expect currency units
            url.searchParams.set(param + '.gte', Math.round(tMin.value / 100));
            url.searchParams.set(param + '.lte', Math.round(tMax.value / 100));
            filterWithUrl(url.toString());
          }
          return;
        }
      });
    }

    // ── Price sliders ────────────────────────────────
    function initPriceSliders() {
      document.querySelectorAll('.coll-page__price-slider').forEach(function(slider) {
        var thumbMin = slider.querySelector('.coll-page__price-thumb--min');
        var thumbMax = slider.querySelector('.coll-page__price-thumb--max');
        var fill = slider.querySelector('.coll-page__price-fill');
        var numMin = slider.querySelector('.coll-page__price-num--min');
        var numMax = slider.querySelector('.coll-page__price-num--max');
        var rangeMax = parseFloat(slider.dataset.rangeMax) || 1000;

        function updateFill() {
          var lo = parseFloat(thumbMin.value);
          var hi = parseFloat(thumbMax.value);
          fill.style.left = (lo / rangeMax * 100) + '%';
          fill.style.width = ((hi - lo) / rangeMax * 100) + '%';
        }

        var rangeMaxEuros = Math.round(rangeMax / 100);

        thumbMin.addEventListener('input', function() {
          if (+thumbMin.value > +thumbMax.value) thumbMin.value = thumbMax.value;
          numMin.value = Math.round(thumbMin.value / 100);
          updateFill();
        });
        thumbMax.addEventListener('input', function() {
          if (+thumbMax.value < +thumbMin.value) thumbMax.value = thumbMin.value;
          numMax.value = Math.round(thumbMax.value / 100);
          updateFill();
        });
        numMin.addEventListener('change', function() {
          var euros = Math.max(0, Math.min(+numMin.value || 0, +numMax.value || rangeMaxEuros));
          numMin.value = euros;
          thumbMin.value = euros * 100;
          updateFill();
        });
        numMax.addEventListener('change', function() {
          var euros = Math.min(rangeMaxEuros, Math.max(+numMax.value || 0, +numMin.value || 0));
          numMax.value = euros;
          thumbMax.value = euros * 100;
          updateFill();
        });

        [numMin, numMax].forEach(function(input) {
          input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') slider.querySelector('.coll-page__price-apply').click();
          });
        });

        updateFill();
      });
    }

    initPriceSliders();

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.faq__question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq__item');
        var isOpen = item.classList.contains('faq__item--open');

        // Close all items first
        item.closest('.faq__grid').querySelectorAll('.faq__item').forEach(function(el) {
          el.classList.remove('faq__item--open');
          el.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        });

        // Open clicked one only if it was closed
        if (!isOpen) {
          item.classList.add('faq__item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-footer-localization]').forEach(function(control) {
      var btn = control.querySelector('[data-footer-localization-btn]');
      var list = control.querySelector('[data-footer-localization-list]');
      if (!btn || !list) return;

      function closeList() {
        btn.setAttribute('aria-expanded', 'false');
        list.hidden = true;
      }

      function setListBounds() {
        var buttonRect = btn.getBoundingClientRect();
        var viewportWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
        var edgePadding = viewportWidth < 480 ? 12 : 16;
        var dropdownGap = 10;
        var availableAbove = Math.floor(buttonRect.top - dropdownGap - edgePadding);
        var maxHeight = Math.min(360, Math.max(1, availableAbove));

        list.style.setProperty('--footer-currency-max-height', maxHeight + 'px');
      }

      function openList() {
        document.querySelectorAll('[data-footer-localization-list]').forEach(function(otherList) {
          if (otherList === list) return;
          otherList.hidden = true;
          var otherButton = otherList.closest('[data-footer-localization]').querySelector('[data-footer-localization-btn]');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        });

        setListBounds();
        btn.setAttribute('aria-expanded', 'true');
        list.hidden = false;

        var activeOption = list.querySelector('.site-footer__currency-option--active, .site-footer__language-option--active');
        if (activeOption) activeOption.scrollIntoView({ block: 'nearest' });
      }

      function updateOpenList() {
        if (btn.getAttribute('aria-expanded') === 'true') setListBounds();
      }

      btn.addEventListener('click', function() {
        if (btn.getAttribute('aria-expanded') === 'true') {
          closeList();
        } else {
          openList();
        }
      });

      document.addEventListener('click', function(event) {
        if (!control.contains(event.target)) closeList();
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeList();
      });

      window.addEventListener('resize', updateOpenList);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', updateOpenList);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Nav menu
    var navMenu = document.getElementById('nav-menu');
    var navClose = document.getElementById('nav-menu-close');
    var menuBtns = document.querySelectorAll('.site-header__menu-btn, .site-header-compact__menu-btn');
    var searchInputs = document.querySelectorAll('.site-header__search-input, .site-header-compact__search-input');

    function syncHeaderSearchInputs() {
      var url = new URL(window.location.href);
      var isSearchPage = url.pathname.indexOf('/search') === 0;
      var query = isSearchPage ? (url.searchParams.get('q') || '') : '';

      searchInputs.forEach(function(input) {
        input.value = query;
      });
    }

    syncHeaderSearchInputs();
    window.addEventListener('pageshow', syncHeaderSearchInputs);

    function openMenu() {
      if (window.closeCartDrawer) window.closeCartDrawer();
      navMenu.classList.add('is-open');
      navMenu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
      navMenu.classList.remove('is-open');
      navMenu.setAttribute('aria-hidden', 'true');
    }

    window.closeNavMenu = closeMenu;

    menuBtns.forEach(function(btn) {
      btn.addEventListener('click', openMenu);
    });

    // Cart drawer
    document.querySelectorAll('.site-header__cart-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.openCartDrawer) window.openCartDrawer();
      });
    });

    if (navClose) navClose.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMenu();
    });

    var header = document.querySelector('[data-site-header]');
    var bar = document.querySelector('.announcement-bar');
    if (!header) return;

    // Hover via mousemove position check — bypasses SVG pointer-event issues
    if (header.classList.contains('site-header--transparent')) {
      document.addEventListener('mousemove', function(e) {
        var rect = header.getBoundingClientRect();
        var over = e.clientX >= rect.left && e.clientX <= rect.right &&
                   e.clientY >= rect.top  && e.clientY <= rect.bottom;
        header.classList.toggle('site-header--hovered', over);
      }, { passive: true });
    }

    function updateAnnouncementHeight() {
      var h = bar ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }

    updateAnnouncementHeight();

    if (window.ResizeObserver && bar) {
      new ResizeObserver(updateAnnouncementHeight).observe(bar);
    }

    var compact = document.querySelector('[data-site-header-compact]');

    // Threshold: announcement bar height (scrolls away naturally) + large header height
    var announcementHeight = bar ? bar.offsetHeight : 0;
    var compactThreshold = announcementHeight + 110;

    window.addEventListener('scroll', function() {
      var scrolledPastLarge = window.scrollY > compactThreshold;
      if (compact) {
        compact.classList.toggle('site-header-compact--visible', scrolledPastLarge);
        compact.setAttribute('aria-hidden', String(!scrolledPastLarge));
      }
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var hero = document.querySelector('[data-hero-container]');
    if (!hero) return;

    var slides = hero.querySelector('[data-hero-slides]');
    var items = Array.prototype.slice.call(hero.querySelectorAll('.hero-item'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var currentIndicator = hero.querySelector('[data-hero-current]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplayDelay = parseInt(hero.getAttribute('data-hero-autoplay'), 10) || 5000;
    var autoplayTimer = null;
    var activeIndex = 0;
    var scrollRaf = null;

    function formatIndex(index) {
      var visibleIndex = index + 1;
      return visibleIndex < 10 ? '0' + visibleIndex : String(visibleIndex);
    }

    function setActiveIndex(index) {
      if (!items.length) return;

      activeIndex = Math.max(0, Math.min(index, items.length - 1));

      dots.forEach(function(dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (currentIndicator) {
        currentIndicator.textContent = formatIndex(activeIndex);
      }
    }

    function scrollToSlide(index, smooth) {
      if (!items.length) return;

      var targetIndex = Math.max(0, Math.min(index, items.length - 1));
      if (!slides) return;

      var left = targetIndex * slides.clientWidth;

      slides.scrollTo({
        left: left,
        behavior: smooth ? 'smooth' : 'auto'
      });

      setActiveIndex(targetIndex);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (!mobileQuery.matches) return;
      if (reduceMotionQuery.matches) return;
      if (items.length < 2) return;

      autoplayTimer = window.setInterval(function() {
        scrollToSlide((activeIndex + 1) % items.length, true);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function activate(item) {
      hero.classList.add('hero--active');
      items.forEach(function(i) { i.classList.remove('hero-item--active'); });
      item.classList.add('hero-item--active');
    }

    function deactivate() {
      hero.classList.remove('hero--active');
      items.forEach(function(i) { i.classList.remove('hero-item--active'); });
    }

    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        activate(item);
      });

      item.addEventListener('mouseleave', function(e) {
        // Only deactivate when leaving to something outside the hero items
        // (moving between panels keeps the animation alive)
        if (!e.relatedTarget || !e.relatedTarget.closest('.hero-item')) {
          deactivate();
        }
      });

      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var link = item.querySelector('a.hero-item__button');
          if (link) link.click();
        }
      });
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(dot.getAttribute('data-hero-index'), 10);
        if (Number.isNaN(index)) return;

        scrollToSlide(index, true);
        restartAutoplay();
      });
    });

    if (slides) {
      slides.addEventListener('scroll', function() {
        if (!mobileQuery.matches) return;

        if (scrollRaf) {
          window.cancelAnimationFrame(scrollRaf);
        }

        scrollRaf = window.requestAnimationFrame(function() {
          var index = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
          setActiveIndex(index);
        });
      }, { passive: true });
    }

    if (slides) {
      slides.addEventListener('touchstart', stopAutoplay, { passive: true });
      slides.addEventListener('touchend', restartAutoplay, { passive: true });
      slides.addEventListener('touchcancel', restartAutoplay, { passive: true });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', restartAutoplay);
      reduceMotionQuery.addEventListener('change', restartAutoplay);
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        restartAutoplay();
      }
    });

    setActiveIndex(0);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    // ── Tab switching ────────────────────────────
    var btns = document.querySelectorAll('[data-tab]');
    var panels = document.querySelectorAll('[data-panel]');

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.dataset.tab;

        btns.forEach(function(b) { b.classList.remove('password-page__nav-btn--active'); });
        btn.classList.add('password-page__nav-btn--active');

        panels.forEach(function(panel) {
          if (panel.dataset.panel === tab) {
            panel.classList.remove('password-page__panel--hidden');
          } else {
            panel.classList.add('password-page__panel--hidden');
          }
        });
      });
    });

    // ── Ghost page overlays ──────────────────────
    document.querySelectorAll('[data-ghost]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var id = 'ghost-' + trigger.dataset.ghost;
        var overlay = document.getElementById(id);
        if (!overlay) return;
        overlay.classList.add('ghost-page--open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-ghost-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var overlay = btn.closest('.ghost-page');
        overlay.classList.remove('ghost-page--open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ticker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('.product-ticker__belt-wrapper');
    var belt = wrapper && wrapper.querySelector('.product-ticker__belt');
    var originalSet = belt && belt.querySelector('.product-ticker__set');
    if (!wrapper || !belt || !originalSet) return;

    // Clone sets until total width covers viewport at least twice
    // On mobile: CSS handles touch-scroll, no cloning needed
    if (window.innerWidth <= 749) return;

    var setWidth = originalSet.scrollWidth;
    if (!setWidth) return;
    var needed = Math.ceil((window.innerWidth * 2) / setWidth) + 1;

    for (var i = 0; i < needed; i++) {
      var clone = originalSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function(a) { a.setAttribute('tabindex', '-1'); });
      belt.appendChild(clone);
    }

    belt.style.setProperty('--set-width', setWidth + 'px');

    wrapper.addEventListener('mouseenter', function() {
      belt.style.animationPlayState = 'paused';
    });
    wrapper.addEventListener('mouseleave', function() {
      belt.style.animationPlayState = 'running';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var productPage = document.querySelector('.product-page');
    var productLabels = {
      addToCart: productPage ? productPage.dataset.labelAddToCart : 'ADD TO CART',
      soldOut: productPage ? productPage.dataset.labelSoldOut : 'SOLD OUT',
      alreadyInCart: productPage ? productPage.dataset.labelAlreadyInCart : 'ALREADY IN CART',
      alreadyInCartMessage: productPage ? productPage.dataset.messageAlreadyInCart : '',
      addError: productPage ? productPage.dataset.messageAddError : ''
    };
    // Lightbox
    var lightbox = document.getElementById('product-lightbox');
    var lightboxScroll = document.getElementById('product-lightbox-scroll');
    var lightboxClose = document.getElementById('product-lightbox-close');
    var lightboxItems = lightbox ? lightbox.querySelectorAll('.product-lightbox__item') : [];

    document.querySelectorAll('[data-lightbox]').forEach(function(box) {
      box.addEventListener('click', function() {
        var index = box.dataset.lightbox;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Scroll to clicked image
        var target = lightboxScroll.querySelector('[data-index="' + index + '"]');
        if (target) {
          setTimeout(function() {
            target.scrollIntoView({ block: 'start' });
          }, 50);
        }
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lightboxScroll.scrollTop = 0;
    }

    lightboxScroll.addEventListener('click', closeLightbox);
    lightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
    });

    // Size variant selection + one-of-one cart limits
    var sizeButtons = document.querySelectorAll('[data-size-buttons] .product-page__size-btn');
    var variantInput = document.getElementById('product-variant-id');
    var productForm = document.querySelector('.product-page form[action*="/cart/add"]');
    var addBtns = productForm ? productForm.querySelectorAll('.product-page__add-to-cart, .product-page__sticky-add-to-cart') : [];
    var primaryAddBtn = productForm && productForm.querySelector('.product-page__add-to-cart');
    var stickyAddBtn = productForm && productForm.querySelector('.product-page__sticky-add-to-cart');
    var cartLimitMessage = productForm && productForm.querySelector('[data-cart-limit-message]');
    var cartQuantitiesByVariant = {};

    function parseNumber(value, fallback) {
      var number = parseInt(value, 10);
      return Number.isNaN(number) ? fallback : number;
    }

    function setCartLimitMessage(message) {
      if (!cartLimitMessage) return;

      if (message) {
        cartLimitMessage.textContent = message;
        cartLimitMessage.hidden = false;
      } else {
        cartLimitMessage.textContent = '';
        cartLimitMessage.hidden = true;
      }
    }

    function getSelectedVariantButton() {
      return document.querySelector('[data-size-buttons] .product-page__size-btn--active') || sizeButtons[0];
    }

    function getSelectedVariantId() {
      if (variantInput && variantInput.value) return String(variantInput.value);

      var selectedVariantButton = getSelectedVariantButton();
      return selectedVariantButton ? String(selectedVariantButton.dataset.variantId) : '';
    }

    function getVariantLimit(variantButton) {
      if (!variantButton) return Infinity;
      if (variantButton.dataset.available !== 'true') return 0;
      if (variantButton.dataset.inventoryPolicy === 'deny') {
        return Math.max(0, parseNumber(variantButton.dataset.inventoryQuantity, 0));
      }
      return Infinity;
    }

    function getCartQuantityForVariant(variantId) {
      return cartQuantitiesByVariant[String(variantId)] || 0;
    }

    function syncCartQuantities(cart) {
      cartQuantitiesByVariant = {};
      if (!cart || !cart.items) return;

      cart.items.forEach(function(item) {
        var variantId = String(item.variant_id);
        cartQuantitiesByVariant[variantId] = (cartQuantitiesByVariant[variantId] || 0) + item.quantity;
      });
    }

    function setAddButtons(label, isDisabled) {
      addBtns.forEach(function(btn) {
        btn.textContent = label;
        btn.disabled = isDisabled;
      });
    }

    function updateAddButtonState() {
      var selectedVariantButton = getSelectedVariantButton();
      var variantId = getSelectedVariantId();
      var variantLimit = getVariantLimit(selectedVariantButton);
      var currentCartQuantity = getCartQuantityForVariant(variantId);
      var isSoldOut = variantLimit <= 0;
      var isCartLimited = variantLimit !== Infinity && currentCartQuantity >= variantLimit;

      if (productForm) {
        productForm.classList.toggle('is-cart-limited', isSoldOut || isCartLimited);
      }

      if (isSoldOut) {
        setAddButtons(productLabels.soldOut, true);
        setCartLimitMessage('');
      } else if (isCartLimited) {
        setAddButtons(productLabels.alreadyInCart, false);
        setCartLimitMessage(productLabels.alreadyInCartMessage);
      } else {
        setAddButtons(productLabels.addToCart, false);
        setCartLimitMessage('');
      }

      return {
        isSoldOut: isSoldOut,
        isCartLimited: isCartLimited,
        variantId: variantId
      };
    }

    function setAddButtonsLoading(isLoading) {
      if (isLoading) {
        setAddButtons('...', true);
      } else {
        updateAddButtonState();
      }
    }

    function updateHeaderCartCount(cart) {
      document.querySelectorAll('.site-header__cart-text, .site-header-compact__cart-text').forEach(function(btn) {
        var cartTitle = document.documentElement.dataset.cartTitle || 'CART';
        btn.textContent = cartTitle + '[' + cart.item_count + ']';
      });

      document.querySelectorAll('.site-header__cart-badge, .site-header-compact__cart-badge').forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
    }

    function renderCartDrawerSection(data) {
      if (!data || !data['cart-drawer']) return;

      var tmp = document.createElement('div');
      tmp.innerHTML = data['cart-drawer'];
      var newHeader = tmp.querySelector('.cart-drawer__header');
      var curHeader = document.querySelector('.cart-drawer__header');
      if (newHeader && curHeader) curHeader.innerHTML = newHeader.innerHTML;

      var newBody = tmp.querySelector('#cart-drawer-body');
      var curBody = document.getElementById('cart-drawer-body');
      if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;

      var newFooter = tmp.querySelector('.cart-drawer__footer');
      var curFooter = document.querySelector('.cart-drawer__footer');
      if (newFooter && curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
      } else if (newFooter && !curFooter) {
        var panel = document.querySelector('.cart-drawer__panel');
        if (panel) panel.appendChild(newFooter);
      } else if (!newFooter && curFooter) {
        curFooter.remove();
      }
    }

    sizeButtons.forEach(function(btn) {
      var variantId = String(btn.dataset.variantId);
      cartQuantitiesByVariant[variantId] = parseNumber(btn.dataset.cartQuantity, 0);

      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('product-page__size-btn--active'); });
        btn.classList.add('product-page__size-btn--active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        updateAddButtonState();
      });
    });

    updateAddButtonState();

    document.addEventListener('cart:updated', function(event) {
      syncCartQuantities(event.detail);
      updateAddButtonState();
    });

    // Shipping accordion
    var accordionBtns = document.querySelectorAll('[data-accordion-btn]');
    accordionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = btn.closest('[data-accordion]').querySelector('[data-accordion-body]');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        body.classList.toggle('is-open', !isOpen);
      });
    });

    // Measurement guide popup
    document.querySelectorAll('[data-measurement-guide]').forEach(function(dialog) {
      var openButton = document.querySelector('[data-measurement-guide-open]');
      var closeButton = dialog.querySelector('[data-measurement-guide-close]');
      var previouslyFocusedElement = null;

      if (!openButton || !closeButton) return;

      openButton.addEventListener('click', function() {
        previouslyFocusedElement = document.activeElement;
        dialog.showModal();
      });

      closeButton.addEventListener('click', function() {
        dialog.close();
      });

      dialog.addEventListener('click', function(event) {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function() {
        if (previouslyFocusedElement) previouslyFocusedElement.focus();
      });
    });

    // Add to cart → open drawer instead of redirecting
    if (productForm && addBtns.length) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        setAddButtonsLoading(true);

        fetch(shopRoot + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          syncCartQuantities(cart);
          var currentState = updateAddButtonState();
          if (currentState.isSoldOut || currentState.isCartLimited) {
            throw { type: 'cart-limit' };
          }

          return fetch(shopRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: currentState.variantId, quantity: 1 })
          });
        })
        .then(function(r) {
          if (!r.ok) {
            return r.json().then(function(error) { throw error; });
          }
          return r.json();
        })
        .then(function() {
          return Promise.all([
            fetch(shopRoot + '?sections=cart-drawer').then(function(r) { return r.json(); }),
            fetch(shopRoot + 'cart.js').then(function(r) { return r.json(); })
          ]);
        })
        .then(function(results) {
          var data = results[0];
          var cart = results[1];
          syncCartQuantities(cart);
          updateHeaderCartCount(cart);
          renderCartDrawerSection(data);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          setAddButtonsLoading(false);
          if (window.openCartDrawer) window.openCartDrawer();
        })
        .catch(function(error) {
          setAddButtonsLoading(false);

          if (error && error.type === 'cart-limit') {
            updateAddButtonState();
            if (window.openCartDrawer) window.openCartDrawer();
            return;
          }

          setCartLimitMessage((error && error.description) || productLabels.addError);
        });
      });
    }

    if (primaryAddBtn && stickyAddBtn) {
      function updateStickyAddButton() {
        if (window.innerWidth > 749) {
          stickyAddBtn.classList.remove('is-visible');
          return;
        }

        var rect = primaryAddBtn.getBoundingClientRect();
        var primaryIsVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        stickyAddBtn.classList.toggle('is-visible', !primaryIsVisible);
      }

      if ('IntersectionObserver' in window) {
        var stickyObserver = new IntersectionObserver(function(entries) {
          if (window.innerWidth > 749) {
            stickyAddBtn.classList.remove('is-visible');
            return;
          }
          stickyAddBtn.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, {
          threshold: 0.01,
          rootMargin: '0px 0px -72px 0px'
        });

        stickyObserver.observe(primaryAddBtn);
      }

      updateStickyAddButton();
      window.addEventListener('scroll', updateStickyAddButton, { passive: true });
      window.addEventListener('resize', updateStickyAddButton);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var filterOpen = document.getElementById('search-filter-open');
    var filterClose = document.getElementById('search-filter-close');
    var filterDrawer = document.getElementById('search-filter-drawer');
    var filterOverlay = document.getElementById('search-filter-overlay');

    function openDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (filterOpen) filterOpen.addEventListener('click', openDrawer);
    if (filterClose) filterClose.addEventListener('click', closeDrawer);
    if (filterOverlay) filterOverlay.addEventListener('click', closeDrawer);

    document.querySelectorAll('[data-search-reset]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        document.querySelectorAll('.site-header__search-input, .site-header-compact__search-input').forEach(function(input) {
          input.value = '';
        });

        var referrer = document.referrer ? new URL(document.referrer) : null;
        var canGoBack = window.history.length > 1 &&
          referrer &&
          referrer.origin === window.location.origin &&
          referrer.href !== window.location.href;

        if (canGoBack) {
          e.preventDefault();
          window.history.back();
        }
      });
    });

    function setLoading() {
      var page = document.querySelector('.search-page');
      if (page) page.classList.add('is-loading');
    }

    if (filterDrawer) {
      filterDrawer.addEventListener('click', function(e) {
        var accordBtn = e.target.closest('.search-page__accord-btn');
        if (accordBtn) {
          var accord = accordBtn.closest('.search-page__accord');
          var isOpen = accordBtn.getAttribute('aria-expanded') === 'true';
          accordBtn.setAttribute('aria-expanded', String(!isOpen));
          accord.classList.toggle('search-page__accord--open', !isOpen);
          return;
        }

        var drawerSort = e.target.closest('[data-drawer-sort]');
        if (drawerSort) {
          var sortUrl = new URL(window.location.href);
          sortUrl.searchParams.set('sort_by', drawerSort.dataset.drawerSort);
          setLoading();
          window.location.href = sortUrl.toString();
          return;
        }

        var filterLink = e.target.closest('.search-page__drawer-filter, .search-page__active-chip, .search-page__clear-all');
        if (filterLink) {
          setLoading();
          return;
        }

        var applyBtn = e.target.closest('.search-page__price-apply');
        if (applyBtn) {
          var slider = applyBtn.closest('.search-page__price-slider');
          if (slider) {
            var tMin = slider.querySelector('.search-page__price-thumb--min');
            var tMax = slider.querySelector('.search-page__price-thumb--max');
            var param = slider.dataset.param || 'filter.p.m.price';
            var priceUrl = new URL(window.location.href);
            // Thumbs hold cents; the filter URL params expect currency units
            priceUrl.searchParams.set(param + '.gte', Math.round(tMin.value / 100));
            priceUrl.searchParams.set(param + '.lte', Math.round(tMax.value / 100));
            setLoading();
            window.location.href = priceUrl.toString();
          }
        }
      });
    }

    function initPriceSliders() {
      document.querySelectorAll('.search-page__price-slider').forEach(function(slider) {
        var thumbMin = slider.querySelector('.search-page__price-thumb--min');
        var thumbMax = slider.querySelector('.search-page__price-thumb--max');
        var fill = slider.querySelector('.search-page__price-fill');
        var numMin = slider.querySelector('.search-page__price-num--min');
        var numMax = slider.querySelector('.search-page__price-num--max');
        var rangeMax = parseFloat(slider.dataset.rangeMax) || 1000;
        var rangeMaxEuros = Math.round(rangeMax / 100);

        function updateFill() {
          var lo = parseFloat(thumbMin.value);
          var hi = parseFloat(thumbMax.value);
          fill.style.left = (lo / rangeMax * 100) + '%';
          fill.style.width = ((hi - lo) / rangeMax * 100) + '%';
        }

        thumbMin.addEventListener('input', function() {
          if (+thumbMin.value > +thumbMax.value) thumbMin.value = thumbMax.value;
          numMin.value = Math.round(thumbMin.value / 100);
          updateFill();
        });

        thumbMax.addEventListener('input', function() {
          if (+thumbMax.value < +thumbMin.value) thumbMax.value = thumbMin.value;
          numMax.value = Math.round(thumbMax.value / 100);
          updateFill();
        });

        numMin.addEventListener('change', function() {
          var euros = Math.max(0, Math.min(+numMin.value || 0, +numMax.value || rangeMaxEuros));
          numMin.value = euros;
          thumbMin.value = euros * 100;
          updateFill();
        });

        numMax.addEventListener('change', function() {
          var euros = Math.min(rangeMaxEuros, Math.max(+numMax.value || 0, +numMin.value || 0));
          numMax.value = euros;
          thumbMax.value = euros * 100;
          updateFill();
        });

        [numMin, numMax].forEach(function(input) {
          input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') slider.querySelector('.search-page__price-apply').click();
          });
        });

        updateFill();
      });
    }

    initPriceSliders();
  });

  } catch(e) { console.error(e); }
})();
})();
